import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const LogAdPartnerSearch = new ReduxAsyncAction<'LOG_AD_PARTNER_SEARCH', string, void>('LOG_AD_PARTNER_SEARCH');

LogAdPartnerSearch.registerRequest(async (text) => {
  await dash_api.post<void>('/v1/ad-network/log-search', { text });
});

export const LOG_AD_PARTNER_SEARCH = LogAdPartnerSearch.actionNamespaceConstants;

export const logAdPartnerSearch = LogAdPartnerSearch.request;

export type LogAdPartnerSearchResponseAction = Action<typeof LOG_AD_PARTNER_SEARCH.response>;
